module.exports = function anonymous(it
/**/) {
var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Hong-Ou-Mandel interference between signal and idler photons</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-homjsa">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/jsa-2hom-layout.tpl
 ** module id = 503
 ** module chunks = 1
 **/